import { useCallback } from "react";

const LandingBanner = () => {
  const scrollTo = useCallback((id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <section className="pt-16 lg:pt-20">
      <div className="relative w-full h-[70vh] min-h-[500px] overflow-hidden">
        <img 
          src="/images/hero-animals.jpg" 
          alt="Animals in nature"
          className="absolute inset-0 w-full h-full object-cover"
        />
        
        <div className="absolute inset-0 bg-gradient-to-b from-[#4a6e69]/60 via-[#4a6e69]/40 to-[#f7f8f7]" />

        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          <div className="max-w-3xl flex flex-col items-center gap-6">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white drop-shadow-lg leading-tight">
              Welcome to All Animal App
            </h1>
            <p className="text-lg md:text-xl text-white/90 font-medium leading-relaxed max-w-2xl drop-shadow-md">
              A centralized global platform for all animal welfare needs
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4 mt-4">
              <button
                type="button"
                onClick={() => scrollTo("about")}
                className="bg-white text-[#4a6e69] font-semibold px-8 py-3.5 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl hover:bg-white/95 text-base"
              >
                Learn More
              </button>
              <button
                type="button"
                onClick={() => scrollTo("features")}
                className="bg-white/15 hover:bg-white/25 border border-white/30 text-white font-semibold px-8 py-3.5 rounded-full transition-all duration-200 backdrop-blur-sm text-base"
              >
                Explore Technology
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingBanner;
